module.exports = "https://static.wmbcdn.com/uniweb/images/a3b027334e9bd50571fd907706a637d1.svg";